(function () {
  function initBestsellers(root) {
    if (!root || root.dataset.btsInitialized === 'true') return;
    root.dataset.btsInitialized = 'true';

    var tabs = root.querySelectorAll('.bts__tab');
    var panels = root.querySelectorAll('.bts__panel');
    var prevBtn = root.querySelector('[data-bts-prev]');
    var nextBtn = root.querySelector('[data-bts-next]');
    var currentEl = root.querySelector('[data-bts-current]');
    var totalEl = root.querySelector('[data-bts-total]');
    var tabsScroller = root.querySelector('[data-bts-tabs-scroller]');
    var tabsPrevBtn = root.querySelector('[data-bts-tabs-prev]');
    var tabsNextBtn = root.querySelector('[data-bts-tabs-next]');
    var tabsFade = root.querySelector('.bts__tabs-fade');

    function updateTabsFade() {
      if (!tabsScroller || !tabsFade) return;
      var atEnd = tabsScroller.scrollLeft + tabsScroller.clientWidth >= tabsScroller.scrollWidth - 1;
      tabsFade.classList.toggle('is-hidden', atEnd);
    }

    function getActiveTrack() {
      var panel = root.querySelector('.bts__panel.is-active');
      return panel ? panel.querySelector('[data-bts-track]') : null;
    }

    function getCardsPerView() {
      var value = parseInt(getComputedStyle(root).getPropertyValue('--bts-cards-per-view'), 10);
      return value > 0 ? value : 1;
    }

    function getStep(track) {
      var card = track.children[0];
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return (card.getBoundingClientRect().width + gap) * getCardsPerView();
    }

    function updatePagination() {
      var track = getActiveTrack();
      if (!track) return;

      var count = track.children.length;
      var perView = getCardsPerView();
      var totalPages = Math.max(1, Math.ceil(count / perView));
      var step = getStep(track);
      var maxScrollLeft = track.scrollWidth - track.clientWidth;
      var page;

      if (maxScrollLeft <= 0 || track.scrollLeft >= maxScrollLeft - 1) {
        // Last page is often partial (fewer than perView cards left), so its
        // scroll offset doesn't land on an exact step multiple. Detect the
        // scroll end directly instead of relying on step-based rounding.
        page = totalPages;
      } else if (step > 0) {
        page = Math.round(track.scrollLeft / step) + 1;
      } else {
        page = 1;
      }
      page = Math.min(Math.max(page, 1), totalPages);

      if (currentEl) currentEl.textContent = page;
      if (totalEl) totalEl.textContent = '/' + totalPages;
      if (prevBtn) prevBtn.disabled = page <= 1;
      if (nextBtn) nextBtn.disabled = page >= totalPages;
    }

    var scrollTimeout;
    panels.forEach(function (panel) {
      var track = panel.querySelector('[data-bts-track]');
      if (!track) return;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updatePagination, 80);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var track = getActiveTrack();
        if (track) track.scrollBy({ left: -getStep(track), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var track = getActiveTrack();
        if (track) track.scrollBy({ left: getStep(track), behavior: 'smooth' });
      });
    }

    var handleResize = function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updatePagination, 80);
      updateTabsFade();
    };
    root.btsResizeHandler = handleResize;
    window.addEventListener('resize', handleResize);

    if (tabsScroller) {
      tabsScroller.addEventListener('scroll', updateTabsFade);
    }

    var tabList = Array.prototype.slice.call(tabs);

    function activateTab(tab) {
      if (!tab) return;
      var targetId = tab.getAttribute('data-panel');

      tabList.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');

      if (tabsScroller) {
        tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        setTimeout(updateTabsFade, 350);
      }

      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-panel-id') === targetId);
      });

      var track = getActiveTrack();
      if (track) track.scrollTo({ left: 0 });
      updatePagination();
    }

    if (tabsPrevBtn) {
      tabsPrevBtn.addEventListener('click', function () {
        var index = tabList.findIndex(function (t) { return t.classList.contains('is-active'); });
        if (index > 0) activateTab(tabList[index - 1]);
      });
    }

    if (tabsNextBtn) {
      tabsNextBtn.addEventListener('click', function () {
        var index = tabList.findIndex(function (t) { return t.classList.contains('is-active'); });
        if (index > -1 && index < tabList.length - 1) activateTab(tabList[index + 1]);
      });
    }

    tabList.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });
    });

    updatePagination();
    updateTabsFade();
  }

  function initAll(context) {
    (context || document).querySelectorAll('.bts').forEach(initBestsellers);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector ? event.target.querySelector('.bts') : null;
    if (root && root.btsResizeHandler) {
      window.removeEventListener('resize', root.btsResizeHandler);
      root.btsResizeHandler = null;
    }
  });
})();
